import { getAllPaypalPlans } from './getAllPaypalPlans';
// import { loadPaypalSdk } from './loadPaypalSdk';

const initializePaypal = () => {
  getAllPaypalPlans();
  // loadPaypalSdk();
};

export { initializePaypal };
